module.exports = __webpack_public_path__ + "static/img/yk8600.0bd1e69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk8600.png
// module id = Jrhl
// module chunks = 1